"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VideoElement = function (_a) {
    var object = _a.object;
    var _b = object.width, width = _b === void 0 ? 1 : _b, _c = object.height, height = _c === void 0 ? 1 : _c, _d = object.scaleX, scaleX = _d === void 0 ? 1 : _d, _e = object.scaleY, scaleY = _e === void 0 ? 1 : _e, left = object.left, top = object.top, cId = object.cId, cVideoLoop = object.cVideoLoop, cVideoAutoplay = object.cVideoAutoplay, cVideoMuted = object.cVideoMuted;
    var videoElemeentProps = {
        id: cId,
        preload: 'none',
        controls: false,
        width: '100%',
        height: '100%',
        src: object.fileMetadata.url
    };
    if (cVideoLoop) {
        videoElemeentProps.loop = cVideoLoop;
    }
    if (cVideoAutoplay) {
        videoElemeentProps.autoPlay = cVideoAutoplay;
    }
    if (cVideoMuted) {
        videoElemeentProps.muted = cVideoMuted;
    }
    return (react_1.default.createElement("div", { key: cId, style: {
            position: 'absolute',
            width: "".concat(width * scaleX, "px"),
            height: "".concat(height * scaleY, "px"),
            left: "".concat(left, "px"),
            top: "".concat(top, "px"),
            userSelect: 'auto',
            pointerEvents: 'auto'
        } },
        react_1.default.createElement("video", __assign({}, videoElemeentProps))));
};
exports.default = VideoElement;
//# sourceMappingURL=VideoElement.js.map